import RecordManagementModule from "@/modules/RecordManagement";

const RecordManagementPage = () => {
  return <RecordManagementModule />;
};

export default RecordManagementPage;
